import * as z from "zod";
import { onboardingV2OverviewProductScopeSchema } from "./analytics-product-id";
import {
  onboardingV2CustomRangeSchema,
  onboardingV2TimePeriodSchema,
  requireCustomRangeWhenCustom,
} from "./analytics-time-period";

const statusFilterSchema = z.enum([
  "Completed",
  "Reopened",
  "Awaiting approval",
  "In progress",
  "Partial Completion",
  "Help Requested",
]);

const numericFilterSchema = z.object({
  operator: z.enum(["lt", "gt"]),
  value: z.number().min(0),
});

const dateRangeFilterSchema = z.object({
  start: z.string().min(1),
  end: z.string().min(1),
});

export const onboardingV2OverviewAnalyticsInputSchema = z
  .object({
    timePeriod: onboardingV2TimePeriodSchema,
    customRange: onboardingV2CustomRangeSchema.optional(),
    productScope: onboardingV2OverviewProductScopeSchema.default("all"),
    hideArchived: z.boolean().default(true),
    statuses: z.array(statusFilterSchema).optional(),
    startDateRange: dateRangeFilterSchema.optional(),
    durationFilter: numericFilterSchema.optional(),
    dealSizeFilter: numericFilterSchema.optional(),
    filterLowIntent: z.boolean().optional(),
  })
  .superRefine(requireCustomRangeWhenCustom);

export type OnboardingV2OverviewAnalyticsInput = z.infer<
  typeof onboardingV2OverviewAnalyticsInputSchema
>;
